import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getTemplatesListData(token) {
    var response = axios.get(APP_SETTINGS.API_PATH.FEEDBACK.getTemplates, {
        headers: {
            "Authorization": "Bearer " + token
        }
    });
    return response;
}

export function getQuestionsListData(formTypeId, token) {
    return axios.get(`${APP_SETTINGS.API_PATH.FEEDBACK.getQuestions}${formTypeId}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function getReviewsList(token) {
    return axios.get(APP_SETTINGS.API_PATH.FEEDBACK.feedbackReviews, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function getAllevaluationsList(token) {
    return axios.get(APP_SETTINGS.API_PATH.FEEDBACK.getAllEvaluation, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function getAllGiveFeedbackData(userId, token) {
    return axios.get(`${APP_SETTINGS.API_PATH.FEEDBACK.giveFeedback}${userId}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function addEvaluationData(evaluationData, token) {
    return axios.post(APP_SETTINGS.API_PATH.FEEDBACK.AddEvaluation, evaluationData, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function addTemplateData(templateData, token) {
    return axios.post(APP_SETTINGS.API_PATH.FEEDBACK.addTemplate, templateData, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}


export function addQuestionData(questionData, token) {
    return axios.post(APP_SETTINGS.API_PATH.FEEDBACK.addQuestion, questionData, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function deleteQuestionData(QuestionId, token) {
    return axios.post(`${APP_SETTINGS.API_PATH.FEEDBACK.deleteQuestion}${QuestionId}`, { QuestionId: QuestionId }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function deleteTemplateData(templateId, token) {
    var response = axios.post(`${APP_SETTINGS.API_PATH.FEEDBACK.deleteTemplate}${templateId}`, { templateId: templateId }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    });
    // console.log("your resp from deleting is  : ", response);
    return response;
}

export function addAnswersData(answersData, token) {
    return axios.post(APP_SETTINGS.API_PATH.FEEDBACK.addAnswers, answersData, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function getAnswersByEvaluationByIds(evaluationId, formTypeId, token) {
    return axios.get(`${APP_SETTINGS.API_PATH.FEEDBACK.getAnswersByEvaluationId}?EvaluationId=${evaluationId}&FormTypeId=${formTypeId}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function completeEvaluationByIds(completeData, token) {
    return axios.post(APP_SETTINGS.API_PATH.FEEDBACK.completeStatus, completeData, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export function getFilteredEvaluations(name, date, status, token) {
    return axios.get(`${APP_SETTINGS.API_PATH.FEEDBACK.evaluationFiltered}?Name=${name}&Date=${date}&Status=${status}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}